import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import Nav from "@/components/libros/Nav";
import Hero from "@/components/libros/Hero";
import Highlights from "@/components/libros/Highlights";
import About from "@/components/libros/About";
import WhyChooseUs from "@/components/libros/WhyChooseUs";
import Services from "@/components/libros/Services";
import Industries from "@/components/libros/Industries";
import Workflow from "@/components/libros/Workflow";
import TechStack from "@/components/libros/TechStack";
import Clients from "@/components/libros/Clients";
import Testimonials from "@/components/libros/Testimonials";
import Contact from "@/components/libros/Contact";
import Footer from "@/components/libros/Footer";
import { ContactWidget } from "@/components/libros/ContactWidget";
import AccessibilityStatement from "@/components/libros/AccessibilityStatement";

const Home = () => {
  return (
    <div data-testid="home-page" className="bg-white">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Nav />
      <main id="main-content">
        <Hero />
        <Highlights />
        <About />
        <WhyChooseUs />
        <Services />
        <Industries />
        <Workflow />
        <TechStack />
        <Clients />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <MotionConfig reducedMotion="user">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/accessibility-statement" element={<AccessibilityStatement />} />
          </Routes>
          <ContactWidget />
        </BrowserRouter>
      </MotionConfig>
    </div>
  );
}

export default App;
